import { QUERY_DELETE_DELETEINTERACTION, QUERY_GET_INTERACTIONS, QUERY_GET_INTERACTIONSPAG, QUERY_POST_CREATEINTERACTION, QUERY_PUT_EDITINTERACTION } from '../../fetch/constantQueries';
import { baseThunk, getUrl } from '../../fetch/basicThunk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDelete, fetchPut } from '../../fetch/fetchConfig';

export const getInteractions = baseThunk(`interactions/getInteractions`, QUERY_GET_INTERACTIONS, "GET");
export const getInteractionsPag = baseThunk(`interactions/getInteractionsPag`, QUERY_GET_INTERACTIONSPAG, "GET");

export const createInteraction = baseThunk("interaction/create", QUERY_POST_CREATEINTERACTION, "POST");

export const deleteInteraction = createAsyncThunk(
    'interaction/delete/',
    async (interactionId, thunkApi) => {
          const response = await fetch( getUrl() + QUERY_DELETE_DELETEINTERACTION + `${interactionId}`, fetchDelete());
          if (!response.ok){
            throw response.status};
          const data = response.json()
          return data
    }
  );


export const editInteraction = baseThunk("interaction/update", QUERY_PUT_EDITINTERACTION, "PUT");
